import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/index";
import Methods from "@/assets/js/method.js";
import { signCrypto } from "@/utils/generateSecretKey";
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/home",
      component: Index,
      children: [
        {
          path: "/index",
          component: Index,
          name: "首页"
        }
      ]
    },

    {/* 关于我们 AboutUs*/
      path: "/aboutUs",
      name: "aboutUs",
      component: () => import("@/views/aboutUs"),
      children: [
        {/* 行业动态inFrom */
          path: "aboutUsInFrom",
          component: () => import("@/views/aboutUs/inFrom.vue"),
          name: "aboutUsInFrom",
        },
        {/* 详情 */
          path: "inFrom/:uid/:tid",
          component: () => import("@/views/aboutUs/detail.vue"),
        },
        {
          path: "inFor/:data",
          component: () => import("@/views/aboutUs/inFor.vue"),
          name: "inFor"
        }
      ]
    },

    /* 产品解决方案proDucts的效果图 */
    {
      path: "/design",
      name: "design",
      component: () => import("@/views/proDucts/design.vue"),
    },
    /* 产品解决方案proDucts */
    {
      path: "/proDucts",
      name: "proDucts",
      component: () => import("@/views/proDucts"),
      children: [
        /* {
          path: "inFrom",
          component: ()=>import("@/views/proDucts/inFrom.vue"),
          name:"proDuctsInFrom"
        }, */
        {
          path: "inFrom/:uid/:tid",
          component: () => import("@/views/proDucts/detail.vue"),
        },
        {
          path: "inFor/:data",
          component: () => import("@/views/aboutUs/inFor.vue"),
          name: "proDuctsInFor"
        }
      ]
    },

    /* 服务案例 */
    {
      path: "/serverCase",
      name: "serverCase",
      component: () => import("@/views/serverCase"),
      children: [
        {
          path: "serverCaseInFrom/:id",
          component: () => import("@/views/serverCase/inFrom.vue"),
          name: "serverCaseInFrom",
        },
        {
          path: "serverCaseDel/:id/:cid",
          component: () => import("@/views/serverCase/detail.vue"),
          name: "serverCaseDel"
        },
        {
          path: "inFor/:id",
          component: () => import("@/views/serverCase/inFor.vue"),
          name: "serverCaseInFor"
        },
        {// 这是多条文本列表
          path: "serverList/:id",
          component: () => import("@/views/serverCase/textList.vue"),
          name: "serverList"
        }
      ]
    },

    /* 新闻资讯news */
    {
      path: "/news",
      name: "news",
      component: () => import("@/views/news"),
      children: [
        {/* 行业动态inFrom */
          path: "newsInFrom/:id",
          component: () => import("@/views/news/newsInFrom.vue"),
          name: "newsInFrom",
        },/* 详情 */
        {
          path: "newsDetail/:id/:cid",
          component: () => import("@/views/news/detail.vue"),
          name: "newsDetail"
        },
        {
          path: "inFor/:id",
          component: () => import("@/views/news/inFor.vue"),
          name: "newsInFor"
        },
        {// 这是多条文本列表
          path: "textList/:id",
          component: () => import("@/views/news/textList.vue"),
          name: "textList"
        }
      ]
    },

    /* 加入连邦 */
    {
      path: "/joinUs",
      name: "joinUs",
      component: () => import("@/views/joinUs"),
      children: [

        {/* 行业动态inFrom */
          path: "joinUsInFrom/:id",
          component: () => import("@/views/joinUs/joinUsInFrom.vue"),
          name: "joinUsInFrom",
        },/* 详情 */
        {
          path: "joinUsDetail/:id/:cid",
          component: () => import("@/views/joinUs/detail.vue"),
          name: "joinUsDetail"
        },
        {
          path: "joinUsInFor/:id",
          component: () => import("@/views/joinUs/inFor.vue"),
          name: "joinUsInFor"
        },
        {// 这是多条文本列表
          path: "textList/:id",
          component: () => import("@/views/joinUs/textList.vue"),
          name: "joinUsTextList"
        }
      ]
    },

    /* 联系我们 */
    {
      path: "/connectUs",
      name: "connectUs",
      component: () => import("@/views/connectUs"),
      children: [
        {/* 行业动态inFrom */
          path: "inFrom",
          component: () => import("@/views/connectUs/inFrom.vue"),
          name: "connectUsInFrom",
        },
        {/* 详情 */
          path: "inFrom/:uid/:tid",
          component: () => import("@/views/connectUs/detail.vue"),
        }
      ]
    },

    {
      path: "/searchNewsDel",
      component: () => import("@/views/searchNewsDel"),
      name: "searchNewsDel",

    },
    {
      path: "/text",
      component: () => import("@/views/text/index.vue"),
      name: "text",
    },
    /* 8个栏目跳转详情页 */
    {
      path: "/column",
      component: () => import("@/views/column"),
    },
    /* 404 */
    {
      path: '*',
      name: '404',
      component: () => import("@/views/404")
    }
  ]
});
//
function setTitle () {
  const data = {
    signField: [],
    pid: "",
    is_menu: 2,
  };
  const params = signCrypto(data);
  Methods
    .http("/news/achieve_news_category", params, "get")
    .then((res) => {
      if (res.data[0].type === "0") {
        // 分类
        // this.$EventBus.$emit("resData", res.data);
        window.sessionStorage.setItem(
          "listTit",
          JSON.stringify(res.data)
        );
      }
    });
}

function saveSideTit () {
  const data = {
    signField: [],
    pid: "",
  };
  const params = signCrypto(data);
  Methods
    .http("/news/achieve_news_category", params, "get")
    .then((res) => {
      saveClomn(res.data[1].id);
    });
}
/* 分类下的菜单 */
function saveClomn (pid) {
  const params = {
    pid,
  };
  /*   const params = signCrypto(data); */
  Methods
    .http("/news/achieve_news_category", params, "get")
    .then((res) => {
      window.sessionStorage.setItem("promenu", JSON.stringify(res.data));
    });
}

router.beforeEach((to, from, next) => {
  let str = JSON.parse(sessionStorage.getItem("listTit"))
  if (!str) {
    // console.log(11123);
    setTitle()
    saveSideTit()
    setTimeout(() => {
      next()
    }, 1500);
  } else {
    next()
  }


})

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js